import { useEffect } from 'preact/hooks';
import changelogText from '../../CHANGELOG.md?raw';
import { Markdown } from './Markdown';

export function ChangelogModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      class="fixed inset-0 z-50 bg-foreground/40 flex items-center justify-center p-3 sm:p-6"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="changelog-title"
    >
      <div
        class="bg-background border border-border rounded-lg shadow-xl w-full max-w-2xl max-h-[85vh] flex flex-col overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div class="h-12 px-4 sm:px-5 flex items-center border-b border-border shrink-0">
          <h2 id="changelog-title" class="text-sm font-medium">
            Changelog
          </h2>
          <span class="ml-2 text-[11px] text-muted-foreground font-mono">agents-chat</span>
          <button
            class="ml-auto -mr-1.5 inline-flex items-center justify-center size-8 rounded-md text-muted-foreground hover:bg-accent focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50"
            onClick={onClose}
            aria-label="Fechar"
          >
            <i class="ph ph-x text-base" />
          </button>
        </div>
        <div class="flex-1 overflow-y-auto px-4 sm:px-6 py-4 sm:py-5">
          <Markdown content={changelogText} />
        </div>
      </div>
    </div>
  );
}
